module.exports = __webpack_public_path__ + "static/media/edit_proj.a885fccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/edit_proj.jpg
// module id = 1843
// module chunks = 0